<template>
  <div class="forgot-password-page">
    <ForgotPassword />
  </div>
</template>

<script>
import { ForgotPassword } from '@/features/login';

export default {
  components: { ForgotPassword },
};
</script>
